import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { DirectivesModule } from '@library/ui/directives/directives.module';
import { PreviewGraphComponent } from '@library/ui/molecules/preview-graph/preview-graph.component';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';

@Component({
  selector: 'app-temperature-card',
  imports: [PreviewGraphComponent, TextModule, AsyncPipe, PipesModule, DirectivesModule],
  templateUrl: './temperature-card.component.html',
  styleUrl: './temperature-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemperatureCardComponent {
  private readonly weathermapFacade = inject(WeathermapFacade);

  type = EnumMeasureTypes.TEMPERATURE;

  station = this.weathermapFacade.selectedStation;

  getValue(): number {
    return this.station().Temperature?.[this.station().Temperature?.length - 1].y ?? null;
  }
}
